import { PLAYER } from "../../../common/constants.ts";
import type { Player } from "../../../common/types.ts";
import { idb } from "../../db/index.ts";
import { g } from "../../util/index.ts";

// Only notable players stay in the league history. A player who retires this season is deleted, like the
// "unnotable retired players" option of Delete Old Data, when he has no award (the Hall of Fame is an award) and
// never played for a user team. Kept anyway: imported history (stats before the league started), players with
// relatives (their pages link to each other) and players with a retired jersey number.
export const isNotableRetired = (
	p: Pick<Player, "awards" | "statsTids" | "relatives" | "stats" | "pid">,
	userTids: Set<number>,
	startingSeason: number,
	retiredJerseyPids: Set<number>,
) =>
	p.awards.length > 0 ||
	p.statsTids.some((tid) => userTids.has(tid)) ||
	p.relatives.length > 0 ||
	p.stats.some((row) => row.season < startingSeason) ||
	retiredJerseyPids.has(p.pid);

const pruneRetired = async () => {
	const season = g.get("season");
	const userTids = new Set([g.get("userTid"), ...g.get("userTids")]);
	const retiredJerseyPids = new Set<number>();
	for (const t of await idb.cache.teams.getAll()) {
		for (const jersey of t.retiredJerseyNumbers ?? []) {
			if (jersey.pid !== undefined) {
				retiredJerseyPids.add(jersey.pid);
			}
		}
	}

	const retired = await idb.cache.players.indexGetAll(
		"playersByTid",
		PLAYER.RETIRED,
	);
	let numDeleted = 0;
	for (const p of retired) {
		if (
			p.retiredYear === season &&
			!isNotableRetired(
				p,
				userTids,
				g.get("startingSeason"),
				retiredJerseyPids,
			)
		) {
			await idb.cache.players.delete(p.pid);
			numDeleted += 1;
		}
	}
	return numDeleted;
};

export default pruneRetired;
